export * from '@buf/cosmos_ibc.bufbuild_es/ibc/core/client/v1/client_pb.js';
//# sourceMappingURL=client.js.map